export default __webpack_public_path__ + "transfix-maps/icons/D4-newWave.bbfa71d8ff091ccbdd448e84a1797f8b.png";